import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/userContext";
import { useNavigate } from "react-router-dom";
import styles from "./login.module.css";
import Loader from "../../components/loader";
import axios from "axios";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";
import { apiConfig } from "../../commonFunction/apiconfig";

export default function LoginPage() {
  const {
    userLoggedIn,
    setUserLoggedIn,
    setActiveTab,
    userToken,
    setUserToken,
    setIsAdmin
  } = useContext(UserContext);
  const navigate = useNavigate();
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState({
    email: "",
    password: "",
    otp: "",
  });
  const [showPass, setShowPass] = useState(false);

  const handleGetOtp = async () => {
    try {
      setLoading(true);
      const res = await axios.post(apiConfig.login, {
        email: data.email,
        password: data.password,
      });
      setLoading(false);
      setOtpSent(true);
      console.log(res);
      setError("");
    } catch (e) {
      setLoading(false);
      setError(e.response.data.responseMessage);
      console.log(e);
    }
  };
  const handleVerifyOtp = async () => {
    try {
      setLoading(true);
      const res = await axios.post(apiConfig.otpVerify, {
        email: data.email,
        emailOtp: data.otp,
      });
  
      const token = res?.data?.result?.token;
      const adminType = res?.data?.result?.type;
  
      setLoading(false);
      setUserLoggedIn(true);
      setUserToken(token);
      setIsAdmin(adminType);
      localStorage.setItem("token", token);
      localStorage.setItem("isAdmin", adminType);
  
      if (adminType === 2) {
        setActiveTab(0); 
        navigate("/plan-data");
      } else {
        setActiveTab(1); 
        navigate("/users");
      }
  
      setOtpSent(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
      setError(e.response?.data?.responseMessage || "OTP verification failed.");
    }
  };
  
  const handleResendOtp = async () => {
    try {
      setError("");
      setLoading(true);
      const res = await axios.post(apiConfig.resentOtp, {
        email: data.email,
      });
      setLoading(false);
      console.log(res);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };
  useEffect(() => {
    // if(localStorage.getItem("token") !== ""){
    //   setUserToken(localStorage.getItem("token"));
    //   navigate("/users");
    //   return;
    // }

  }, [navigate, userLoggedIn, userToken]);

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginBox}>
        {otpSent ? (
          <div>
            <h1 className={styles?.loginText}>Enter Otp</h1>
            <p>Otp has been sent to admin mail</p>
            <div className={styles.loginFormBox}>
              <input
                type="number"
                placeholder="Otp"
                onChange={(e) => {
                  setData({ ...data, otp: e.target.value });
                }}
              />
              <button
                onClick={() => {
                  handleVerifyOtp();
                }}
              >
                {loading ? <Loader height={20} width={20} /> : "Verify"}
              </button>
            </div>
            {error && <p style={{ color: "red" }}>{error}</p>}
            <p onClick={handleResendOtp}>Resend Otp</p>
          </div>
        ) : (
          <div>
            <h1 className={styles?.loginText}>Login</h1>
            <img src="/logo.png" alt="logo" className={styles?.logoImg} />
            <div className={styles.loginFormBox}>
              <input
                type="text"
                placeholder="Email"
                onChange={(e) => {
                  setData({ ...data, email: e.target.value });
                }}
              />
              <div>
                <input
                  type={!showPass ? "password" : "text"}
                  placeholder="Password"
                  onChange={(e) => {
                    setData({ ...data, password: e.target.value });
                  }}
                />
                <span className={styles.eyePass}>
                  {showPass ? (
                    <FaRegEyeSlash onClick={() => setShowPass(!showPass)} />
                  ) : (
                    <FaRegEye onClick={() => setShowPass(!showPass)} />
                  )}
                </span>
              </div>
              <button
                onClick={() => {
                  // setUserLoggedIn(true);
                  // setActiveTab(1);
                  handleGetOtp();
                }}
              >
                {loading ? <Loader height={20} width={20} /> : "Login"}
              </button>
            </div>
            {error && <p style={{ color: "red" }}>{error}</p>}
          </div>
        )}
      </div>
    </div>
  );
}
